<template>
  <div class="admin-content-header">
    <div class="admin-content-header__main">
      <h1 class="admin-heading">
        <slot name="title">
          {{ title }}
        </slot>
      </h1>
      <slot name="subheader"></slot>
      <p
        v-if="description || $slots.description"
        class="admin-page-description"
      >
        <slot name="description">
          {{ description }}
        </slot>
      </p>
    </div>
    <div v-if="$slots.actions" class="admin-content-header__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: null },
  },
};
</script>
